import { camelizeKeys, decamelizeKeys } from 'fast-case';
import { instance } from '@rsos/sinatra';
import { getAPIHost } from '@rsos/utils/metaTags';
import {
  APILanguageList,
  TranslationLanguage,
  ApiConversationData,
  ConversationData,
} from './chatsTypes';

const baseURL = `${getAPIHost()}/v1/text_to_911/psap`;

export const fetchLanguageList = async (orgName: string) => {
  const response = await instance.get<APILanguageList>(
    `${getAPIHost()}/v1/text_to_911/translation/languages`,
    {
      headers: { 'X-RapidSOS-Org': orgName },
    },
  );
  if (response.status != 200) {
    throw { message: response.data, status: response.status };
  }
  return camelizeKeys(
    response.data.supported_languages,
  ) as TranslationLanguage[];
};

export const fetchConversationData = async (
  orgName: string,
  conversationId: string,
) => {
  const response = await instance.get<ApiConversationData>(
    `${baseURL}/${orgName}/conversations/${conversationId}`,
  );
  if (response.status != 200) {
    throw { message: response.data, status: response.status };
  }
  return camelizeKeys(response.data) as ConversationData;
};

export const setConversationLanguage = async (
  orgName: string,
  {
    conversationId,
    selectedLanguageCode,
    outboundTranslation,
  }: {
    conversationId: string;
    selectedLanguageCode: string | null | undefined;
    outboundTranslation?: boolean;
  },
) => {
  const response = await instance.patch<void>(
    `${baseURL}/${orgName}/conversations/${conversationId}`,
    decamelizeKeys({
      selectedLanguageCode,
      outboundTranslation,
    }),
  );
  if (response.status != 204) {
    throw { message: response.data, status: response.status };
  }
};
